module.exports = __webpack_public_path__ + "static/media/bg-login.31298f9c.jpg";